import { Epic } from 'modules/store'
import { combineEpics } from 'redux-observable'
import { switchMap } from 'rxjs/operators'

import { Providers } from '../core.module'

import * as fromActions from './lookup.actions'

export const allLookupsEpic: Epic<any, any, Providers> = (actions$, _, { lookupService }) => {
  return actions$.ofType<fromActions.GetLookupsAction>(fromActions.GET_LOOKUPS).pipe(
    switchMap((action) => {
      const { payload: langCode } = action

      return lookupService
        .getAll()
        .then((response) => {
          const responseWithLangCode = { ...response, langCode }

          return new fromActions.GetLookupsSuccessAction(responseWithLangCode)
        })
        .catch((reason) => new fromActions.GetLookupsErrorAction(reason))
    })
  )
}

export const departmentLookupsEpic: Epic<any, any, Providers> = (actions$, _, { lookupService }) => {
  return actions$.ofType<fromActions.GetDepartmentLookupsAction>(fromActions.GET_DEPARTMENT_LOOKUPS).pipe(
    switchMap(() =>
      lookupService
        .getDepartments()
        .then((response) => new fromActions.GetDepartmentLookupsSuccessAction(response))
        .catch((reason) => new fromActions.GetDepartmentLookupsErrorAction(reason))
    )
  )
}

export default combineEpics(allLookupsEpic, departmentLookupsEpic)



// WEBPACK FOOTER //
// ./src/app/core/store/lookup.epic.ts